import api from "../../Hooks/axiosApi";

export const getDashboardCounts = () => {
    const response = api.get(`/api/Crm/GetDashboardCounts`);
    return response;
};

export const getLeadStageCounts = () => {
    const response = api.get(`/api/CrmLeads/GetCrmLeadsByParams`);
    return response;
};


export const getStaffStageCounts = async () => {
    //   return await axios.get("/api/ClientDasboard/staff-stage-counts");
    const response = api.get(`/api/ClientDasboard/staff-stage-counts`);
    return response;
};


// Services/CRMAdminServices/CRMDashboardService.ts

export const getNearSaleDeals = (params: any) => {
    const response = api.get('/api/CrmLeads/GetCrmLeadsByParams', { params });
    return response;
};


export const getCrmDDLService = () => {
    const response = api.get('/api/CrmLeads/GetAllLeadDDL');
    return response;
};
// export const getNearSaleDeals = (filters: {
//     stage?: string;
//     staff?: string;
//     pageNumber?: number;
//     pageSize?: number;
// }) => {
//     return api.get('/api/CrmLeads/GetCrmLeadsByParams', {
//         params: {
//             stage: filters.stage || '',
//             staff: filters.staff || '',
//             pageNumber: filters.pageNumber ?? 1,
//             pageSize: filters.pageSize ?? 10
//         }
//     });
// };

export const getStageConversionReport = () => {
    const response = api.get('/api/ClientDasboard/GetStageConversionReport');
    return response;
};

export const getFunnelData = (fromDate: string, toDate: string) => {
    const response = api.get('/api/ClientDasboard/funnel', {
        params: { fromDate, toDate }
    });
    return response;
};
// Stage funnel by the CRM stage list (Common / MB / IP / Other). Dates are AEST calendar dates, inclusive.
export const getStageFunnel = (fromDate: string, toDate: string) => {
    const response = api.get('/api/ClientDasboard/stagefunnel', {
        params: { fromDate, toDate }
    });
    return response;
};
